import { ReactNode } from "react";
import { Provider as ReduxProvider } from "react-redux";

import ServerErrorView from "components/views/ServerErrorView";
import { ApolloWrapper } from "lib/apollo/client";
import { ErrorBoundary } from "lib/bugsnag";
import { generateStore } from "store/new";

export default function Providers({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const store = generateStore();
  return (
    <ErrorBoundary FallbackComponent={ServerErrorView}>
      <ReduxProvider store={store}>
        <ApolloWrapper>{children}</ApolloWrapper>
      </ReduxProvider>
    </ErrorBoundary>
  );
}
